// extracted by mini-css-extract-plugin
export default {"centered":"MagicLinkPage_centered__ynKJE"};